import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface RiskRating {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}

const QUERY_KEY = 'risk-ratings';

/**
 * Fetches all risk ratings from the database.
 * This is reference data shared across all investment types.
 */
export function useRiskRatings() {
  const { user } = useAuth();

  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('risk_ratings' as any)
        .select('*')
        .order('name', { ascending: true });

      if (error) throw error;
      return data as RiskRating[];
    },
    enabled: !!user,
    // Reference data rarely changes — cache aggressively
    staleTime: 1000 * 60 * 60,
  });
}
